namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_customdom, {

		// Dom_wrapper: {
		// 	margin: '1.5rem',
		// 	flex: {
		// 		grow: 1,
		// 	},
		// 	position: 'relative',
		// 	boxShadow: '0 0 0 1.5rem var(--mol_theme_card)',
		// },
		// Dom_wrapper: {
		// 	position: 'absolute',
		// 	width: '100%',
		// 	height: '100%'
		// },

		// '>': {
		// 	'[mol_view_error]': {
		// 		// zIndex: 1,
		// 		// userSelect: 'all',
		// 		'::selection': {
		// 			color: 'white',
		// 			backgroundColor: 'black'
		// 		},
		// 	},
		// },

		// [mol_view][mol_view_error]:not([mol_view_error="Promise"], [mol_view_error="$mol_promise_blocker"])

		Copy_error: {
			width: 'fit-content',
			color: '#ff6666',
		},
		
	} )

}
